<template>
<v-app>
  <main>
    <v-content>
      <!-- <v-container fluid="fluid"> -->

      <v-container>
        <v-row>
          <!-- <div style="position: relative; top: 50%; transform: translateY(50%);">ciao</div> -->
          <!-- <v-col md3="md3"></v-col> -->
          <v-col md6="md6" xs12="xs12" offset-md3="true">
            <header class="display-3">{{title}}
              <blockquote class="mb-4" style="border-left: 0px; padding-left: 0rem;">
                <v-icon class="display-1 primary--text pr-2" style="vertical-align: bottom">people</v-icon>
                {{subtitle}}
              </blockquote>
            </header>

            <!-- <header class="display-3">{{welcome}}</header> -->

            <!-- <transition name="fade">
              <div v-if="error.show">
                <v-alert error v-bind:value="true" class="mb-5">{{error.message}}</v-alert>
              </div>
            </transition> -->

            <v-snackbar :timeout="error.timeout" v-model="error.show" :top="true">
                {{error.message}}
                <v-btn flat class="blue--text" @click.native="error.show = false">Chiudi</v-btn>
            </v-snackbar>

            <v-text-field v-for="m in member.contact"
              :label="m.label" v-model="m.data" :key="m.label" :type="m.type"
              @keyup.enter.native="signUp" >
            </v-text-field>
            <!--
            <v-text-field @keyup.enter.native="signUp" v-model="name" label="Nome e Cognome" ></v-text-field>
            <v-text-field @keyup.enter.native="signUp" v-model="email" label="Email" ></v-text-field>
            <v-text-field @keyup.enter.native="signUp" v-model="passw" label="Password" type="password" ></v-text-field>
            <v-text-field @keyup.enter.native="signUp" v-model="passwRetype" label="Riscrivi password" type="password" ></v-text-field>
             -->
            <div class="text-xs-center">
              <v-btn @click.native="signUp" primary>Iscriviti</v-btn>
              <p class="mt-3">Hai già un account? <router-link :to="{name: 'Login'}">Login</router-link></p>
            </div>

          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </main>
</v-app>
</template>

<script>

// Firebase
import firebase from '../modules/firebase'
// Store
// import store from '../modules/store'

export default {
  data () {
    return {
      // store,
      welcome: 'Benvenuto!',
      title: 'Benvenuto!',
      subtitle: 'In questa pagina richiedi l\'iscrizione all\'associazione 5pani2pesci in qualità di socio',
      // welcome: 'Yam!',
      member: {
        contact: {
          // name: {data: '', label: 'Nome e Cognome', type: 'text'},
          email: {data: '', label: 'Email', type: 'text'},
          passw: {data: '', label: 'Password', type: 'password'},
          passwRetype: {data: '', label: 'Riscrivi password', type: 'password'}
        }
      },
      error: {
        show: false,
        message: ''
      }
    }
  },
  methods: {
    signUp: function () {
      var reqTest = []
      var inpData = this.member.contact
      for (var key in inpData) {
        reqTest.push(!!inpData[key].data)
      }
      var allRequired = reqTest.every((kk) => { return kk })

      if (allRequired) {
        if (inpData.passw.data !== inpData.passwRetype.data) {
          this.error.message = 'Le password non coincidono'
          this.error.show = true
        } else {
          var email = this.member.contact.email.data
          var passw = this.member.contact.passw.data
          firebase.auth().createUserWithEmailAndPassword(email, passw)
          .then(user => {
            firebase.database().ref('members/users/').child(user.uid).set({
              email: this.member.contact.email.data,
              status: 'incomplete' // incomplete // submitted // accepted // active // inactive
            })
            firebase.database().ref('users/').child(user.uid).set({
              email: this.member.contact.email.data,
              provider: 'email'
              // membership: {
                // status: 'incomplete'
              // }
            })
          })
          .catch(e => {
            // console.log(e)
            this.error.show = true
            if (e.code === 'auth/email-already-in-use') {
              this.error.message = 'Questa email è già utilizzata da un altro utente'
            }
            if (e.code === 'auth/invalid-email' || e.code === 'auth/argument-error') {
              this.error.message = 'Email non corretta'
            }
            if (e.code === 'auth/weak-password') {
              this.error.message = 'La password deve contenere almeno 6 caratteri'
            }
          })
        }
      } else {
        this.error.message = 'Tutti i campi sono obbligatori'
        this.error.show = true
      }
    }
  }
}
</script>

<style scoped>
header{
  margin: 5rem 0 2rem 0;
}
.fade-enter-active, .fade-leave-active {
transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
opacity: 0
}
</style>



// WEBPACK FOOTER //
// Signup.vue?7a59b426